import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";

interface MakePaymentParams {
  openingId: string;
  billingId: string;
}

export const useMakePayment = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async ({ billingId }: MakePaymentParams) => {
      const token = await getAccessTokenSilently();

      return request<{ checkoutUrl: string }>({
        method: "POST",
        path: `/api/payment/subscription/billing/${billingId}/checkout`,
        token,
      });
    },
    onSuccess(data) {
      window.location.assign(data.checkoutUrl);
    },
  });

  return {
    makePayment: mutate,
    isMakingPayment: isPending,
    makePaymentError: error,
  };
};
